export default {
  emailCPF: null,
  senha: null,
  mensagemErro: null
}
